import { SVGProps } from 'react';

const SvgSpain = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#spain_svg__a)">
      <path
        fill="#FFDA44"
        d="M0 11.999c0 1.467.264 2.874.746 4.173L12 17.217l11.254-1.044c.482-1.3.746-2.706.746-4.173s-.264-2.874-.746-4.174L12 6.78.746 7.825A12 12 0 0 0 0 11.999"
      />
      <path
        fill="#D80027"
        d="M23.254 7.826C21.558 3.256 17.16 0 12 0S2.442 3.257.746 7.826zM.746 16.176C2.442 20.746 6.84 24.002 12 24.002s9.558-3.257 11.254-7.826z"
      />
    </g>
    <defs>
      <clipPath id="spain_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSpain;
